import { Bell } from "lucide-react";
import { NavIconButton } from "@/components/ui/NavIconButton";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Badge } from "@/components/ui/badge";
import { NotificationList } from "@/components/notifications/NotificationList";
import { useNotifications } from "@/hooks/useNotifications";
import { useUnreadMessageCount } from "@/hooks/messaging/useUnreadMessageCount";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Link } from "react-router-dom";

export function ActivityCenter() {
  const { unreadCount: notificationCount } = useNotifications();
  const { data: messageCount = 0 } = useUnreadMessageCount();
  
  const totalUnread = notificationCount + messageCount;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <NavIconButton
          icon={Bell}
          label="Activity"
          badge={totalUnread}
        />
      </PopoverTrigger>
      
      <PopoverContent className="w-96 p-0" align="end">
        <Tabs defaultValue="all" className="w-full">
          <div className="border-b px-4 pt-4">
            <TabsList className="w-full grid grid-cols-2">
              <TabsTrigger value="all" className="relative">
                All
                {totalUnread > 0 && (
                  <Badge variant="secondary" className="ml-2 h-5 px-1.5 text-xs">
                    {totalUnread}
                  </Badge>
                )}
              </TabsTrigger>
              <TabsTrigger value="alerts" className="relative">
                Notifications
                {notificationCount > 0 && (
                  <Badge variant="secondary" className="ml-2 h-5 px-1.5 text-xs">
                    {notificationCount}
                  </Badge>
                )}
              </TabsTrigger>
            </TabsList>
          </div>
          
          <TabsContent value="all" className="mt-0">
            <ScrollArea className="h-[400px]">
              <div className="p-4 space-y-4">
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="text-sm font-medium">Recent Activity</h4>
                    <Link to="/messages" className="text-xs text-primary hover:underline">
                      View Messages
                    </Link>
                  </div>
                  <NotificationList />
                </div>
              </div>
            </ScrollArea>
          </TabsContent>
          
          <TabsContent value="alerts" className="mt-0">
            <ScrollArea className="h-[400px]">
              <div className="p-4">
                <NotificationList />
              </div>
            </ScrollArea>
          </TabsContent>
        </Tabs>
      </PopoverContent>
    </Popover>
  );
}
